import { Component, Input } from '@angular/core';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'ups-input-with-helper',
    template: `<div>
    <ngl-input [label]="to.label || ''" [fieldLevelHelpTooltip]="to.description || ''">
      <input ngl [type]="type" [required]="to.required" [placeholder]="to.placeholder" class="custom-class" />
      <!-- <input
        *ngIf="!nested"
        ngl
        [type]="type"
        [formControl]="formControl"
        [required]="to.required"
        [placeholder]="to.placeholder"
        class="custom-class"
      /> -->
    </ngl-input>
  </div>`,
    styleUrls: ['./input.type.component.scss'],
    standalone: false
})
export class InputWithHelperTypeComponent extends FieldType {
  @Input() set defaults(opt: FormlyFieldConfig) {
    this.field = opt;
  }
  // @Input() nested: boolean = false;
  get type() {
    return this.to.type || 'text';
  }
}
